import { css } from '@emotion/core';
import { findLastIndex, unset } from 'lodash';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';
import {
  NAV_MAX_HEIGHT,
  NAV_MAX_HEIGHT_SMALL_VIEWPORT,
} from '../../../utils/constants';

export const keyList = keyCount => {
  return css({
    li: {
      // width: percentage + '%',
    },
  });
};
export const containerSizesTop = {
  margin: '0px 0px 0px',
  [MediaQueries.md]: {
    margin: '0px 0px 0px',
  },
  [MediaQueries.lg]: {
    margin: '0px 0px 0px',
  },
  [MediaQueries.sm]: {
    paddingBottom: '0px',
    paddingTop: '0px',
    display: 'none',
  },

  h2: {
    fontSize: '40px',
    lineHeight: '48px',
    letterSpacing: '-0.30000001192092896px',
    textAlign: 'left',
    marginBottom: '48px',
    marginTop: '0px',
    fontWeight: '500',

    [MediaQueries.md]: {
      fontSize: '28px',
      lineHeight: '40px',
      letterSpacing: '-0.4px',
    },
  },

  '.have-3-item': {
    '.commonbox': {
      [MediaQueries.md]: {
        width: '33.3%',
      },
    },
  },

  ' .boxmain': {
    marginTop: '15px',
    borderBottom: '#D9DBDD solid 1px',
    padding: '0px 0px 55px 0px',
    marginLeft: '0px',
    marginRight: '0px',

    '.commonbox': {
      ':first-child': {
        paddingLeft: '0px',
      },
      [MediaQueries.sm]: {
        width: '100%',
        borderBottom: '#EEF0F2 solid 2px',
        marginBottom: '15px',
        paddingBottom: '15px',
      },

      '.innerbox': {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',

        h3: {
          fontSize: '69px',
          lineHeight: '68px',
          letterSpacing: '-0.30000001192092896px',
          textAlign: 'left',
          color: '#008385',
          fontWeight: '300',
          [MediaQueries.md]: {
            fontSize: '48px',
            lineHeight: '56px',
            letterSpacing: '-0.1px',
          },
        },

        p: {
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '24px',
          letterSpacing: '0px',
          textAlign: 'left',
          marginTop: '32PX',
          color: '#888888',
          [MediaQueries.md]: {
            marginTop: '16PX',
          },
          [MediaQueries.lg]: {
            marginTop: '16PX',
          },
        },

        '.textsec': {
          fontSize: '18px',
          lineHeight: '24px',
          letterSpacing: '0px',
          textAlign: 'left',
          color: '#000000',
          fontWeight: '500',
        },

        img: {
          marginBottom: '15px',
        },
        '.hrline': {
          display: 'flex',
          width: '40px',
          height: '8px',

          '.seperator': {
            borderBottom: '#E52500 solid 4px',
            height: '4px',
            width: '40px',

            outline: 'none',
            borderTop: '0',
            borderRight: '0',
            borderLeft: '0',
            [MediaQueries.sm]: {
              display: 'none',
            },
          },
        },
      },
    },

    '.commonbox:last-child': {
      [MediaQueries.sm]: {
        borderBottom: '0px',
        marginBottom: '0px',
        paddingBottom: '0px',
      },
    },
  },
};

export const FeatureBulletLink = {};

export const itemsContainerCss = css({
  paddingBottom: '0px',
  paddingTop: '0px',
});
